import axios from "axios";
import { helper } from "../helper.js";
import Abstract from "./Abstract";
export const base_url = "/users";
export const url = process.env.VUE_APP_API_BASE_URL + base_url;
export const abstract = new Abstract(url);
export default class Usuarios {
  static get(params) {
    return abstract.get({ ...params });
  }

  static find(id, params) {
    return abstract.find(id, params);
  }

  static update(model) {
    return axios.post(
      url + "/" + model.id,
      helper.getFormData({ ...model, _method: "put" })
    );
  }

  static create(model) {
    return axios.post(url, helper.getFormData(model));
  }

  static submit(model) {
    return abstract.submit(model, false); // qnd true é passado é para ser convertido em formData
  }

  static delete(id) {
    return abstract.delete(id);
  }

  static suspend({ user_id, suspended_at, suspension_reason }) {
    const suspendUrl = process.env.VUE_APP_API_BASE_URL + "/users/suspend";
    return axios.post(suspendUrl, { user_id, suspended_at, suspension_reason });
  }

  static unsuspend(user_id) {
    const unsuspendUrl = process.env.VUE_APP_API_BASE_URL + "/users/unsuspend";
    return axios.post(unsuspendUrl, { user_id });
  }

  static roles() {
    return [
      { id: 1, name: "Superadmin" },
      { id: 2, name: "Admin" },
      { id: 3, name: "Operator" },
      { id: 4, name: "Client" },
      { id: 5, name: "Operator - SubAgent" },
    ];
  }
}
